var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1750_2932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9449 0 0 17.9449 0 40C0 62.0551 17.9449 80 40 80C62.0551 80 80 62.0551 80 40C80 17.9449 62.0551 0 40 0ZM62.3559 29.4737L36.792 54.8371C35.2882 56.3409 32.8822 56.4411 31.2782 54.9373L17.7444 42.6065C16.1404 41.1028 16.0401 38.5965 17.4436 36.9925C18.9474 35.3885 21.4536 35.2882 23.0576 36.792L33.7845 46.6165L56.6416 23.7594C58.2456 22.1554 60.7519 22.1554 62.3559 23.7594C63.9599 25.3634 63.9599 27.8697 62.3559 29.4737Z",
    fill: "url(#paint0_linear_1750_2932)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1750_2932",
    x1: 40,
    y1: -0.00019548,
    x2: 40,
    y2: 79.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2020FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1750_2932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success_tick.100fceee9f1159d1d651b8950f4f6c33.svg";
export { ForwardRef as ReactComponent };